<template>
  <div class="programme-banner">
    <img :src="programmeBanner" alt="" />
    <div class="absolute">
      <div class="title">智慧物业一站式解决方案</div>
      <div class="text">物业管理新升级 社区生活更美好 为物业赋能降本增效</div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../components/pc/components/Experience.vue";

import programmeBanner from "../../../assets/programme/programmeBanner.png";

export default {
  setup() {
    return reactive({
      programmeBanner: programmeBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.programme-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .programme-banner {
    min-width: 1180px;
  }
}
.programme-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 30%;
  left: 33%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
